var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5805 13.5C16.1425 13.5 16.5895 13.1464 16.9908 12.6519C17.8124 11.6396 16.4635 10.8306 15.949 10.4345C15.426 10.0317 14.8421 9.80356 14.25 9.75M13.5 8.25C14.5355 8.25 15.375 7.41053 15.375 6.375C15.375 5.33947 14.5355 4.5 13.5 4.5",
    stroke: "#101928",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41947 13.5C1.85749 13.5 1.4105 13.1464 1.00916 12.6519C0.187566 11.6396 1.5365 10.8306 2.05098 10.4345C2.57398 10.0317 3.15794 9.80356 3.75 9.75M4.125 8.25C3.08947 8.25 2.25 7.41053 2.25 6.375C2.25 5.33947 3.08947 4.5 4.125 4.5",
    stroke: "#101928",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06285 11.3334C5.29652 11.8072 3.28724 12.7748 4.51102 13.9856C5.10883 14.577 5.77464 15 6.61172 15H11.3883C12.2254 15 12.8912 14.577 13.489 13.9856C14.7128 12.7748 12.7035 11.8072 11.9371 11.3334C10.1401 10.2222 7.85989 10.2222 6.06285 11.3334Z",
    stroke: "#101928",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 5.625C11.625 7.07475 10.4497 8.25 9 8.25C7.55025 8.25 6.375 7.07475 6.375 5.625C6.375 4.17525 7.55025 3 9 3C10.4497 3 11.625 4.17525 11.625 5.625Z",
    stroke: "#101928",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.5c3b4824fd9f989858754240eabbc1f2.svg";
export { ForwardRef as ReactComponent };